import { AD_SLOT_PREFIX } from "@config/AdsConstants";
import { AdvertisementTypeEnum } from "@typings/Ads.d";
import { useEffect, useRef, useState } from "react";

export function useAdvertLoaded(type: AdvertisementTypeEnum, id?: string) {
  const [advertLoaded, setAdvertLoaded] = useState(false);
  const targetNodeRef = useRef<HTMLElement | null>(null);

  useEffect(() => {
    const targetNodeId = id || generateAdvertElementId(type);
    const callBack = () => {
      if (
        targetNodeRef.current?.children[0]?.firstElementChild?.tagName ===
        "IFRAME"
      ) {
        setAdvertLoaded(true);
      }
    };

    targetNodeRef.current = document.getElementById(targetNodeId);
    const observer = new MutationObserver(callBack);

    if (targetNodeRef.current) {
      observer.observe(targetNodeRef.current, {
        childList: true,
        subtree: true,
      });
    }
  }, [id, type, setAdvertLoaded]);

  return advertLoaded;
}

export const generateAdvertElementId = (type: AdvertisementTypeEnum) => {
  return `dfp-ad-${type}`;
};

/**
 * Generate the Google Ads slot id based on the parent section unique name.
 * In-article ads is having a different slot prefix with `midarticlespecial`
 *
 * @param {AdvertisementTypeEnum} unit
 * @param {string} sectionUniqueName route name where the ad slot will be generated
 *
 * @example
 * ```ts
 *  GoogleAdsSlotFactory(AdvertisementTypeEnum.LB1, "news/singapore");
 *
 *  ### Result
 *  "/5908/Tabla/lb1/news/singapore"
 * ```
 *
 * @returns string
 */
export const GoogleAdsSlotFactory = (
  unit: AdvertisementTypeEnum,
  sectionUniqueName: string,
): string => {
  const prefix: string = AD_SLOT_PREFIX;

  return `${prefix}/${unit}/${sectionUniqueName}`;
};
